import { CRS, extend, Transformation } from "leaflet";

export default new (function () {
  const navigationCRS = {
    transformation: new Transformation(0.5, 0, 0.5, 0)
  };
  return extend({}, CRS.Simple, navigationCRS);
})();
